/**
 * All breakpoints LMDS uses currently.
 */
export var BREAKPOINTS = ['base', 'sm', 'md', 'lg', 'xl'];